import { motion } from "framer-motion";

export default function Marquee() {
  const items = [
    "Revenue Optimisation",
    "Nightclub Audits",
    "Menu Engineering",
    "Guest Experience",
    "Operations",
    "Pre-Launch",
    "Hospitality Strategy",
    "20+ Years Behind the Decks",
  ];
  const doubled = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      aria-hidden
      className="relative py-12 md:py-24 border-y border-white/5 bg-[#050505] overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="marquee"
      >
        <div className="marquee-track">
          {doubled.map((t, i) => (
            <span
              key={i}
              className="font-display italic text-[40px] sm:text-[56px] md:text-[92px] lg:text-[128px] leading-none whitespace-nowrap flex items-center gap-8 sm:gap-16"
            >
              <span
                className={
                  i % 2 === 0
                    ? "text-white/80"
                    : "text-transparent [-webkit-text-stroke:1px_#D4AF37]"
                }
              >
                {t}
              </span>
              <span className="text-[#D4AF37] text-2xl sm:text-3xl md:text-5xl">✦</span>
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
